// Enum-like object

const LandingPages = [
    'promo',
    'promoint',
    'pedim',
    'pedim-ext',
    'qcm',
    'qcm-ext',
    'jsterling',
    'daniblifting',
    'mhst',
    'sleep-care',
    'free6',
    'mhst6',
    'scofa-1gdxmk',
    'scofa-3m8qmx',
    'scofa-6kdxmv',
    'scofa-50qypz',
    'celebratemom2025'
]

const DealPages = [
    'deal'
]

const MediaTypes = {
    'relaxation': 'Relax & Rest',
    'articles': 'AV Articles',
    'stories': 'Stories',
}

const Categories = {
    'sounds': 'sounds',
    'music': 'music',
    'audio': 'audio',
    'my_mix': 'my-mix',
    'playlist': 'playlist',
    'mix': 'mix'
}

const Common = Object.freeze({
    FEATUREDMIXES: 'Featured Mixes',
    FEATUREDMIX: 'featured-mix',
    RELAXATION: 'relaxation',
    RELAXANDREST: 'Relax & Rest',
    ARTICLES: 'articles',
    RELAXREST: 'relax-rest',
    MIXURE: "mixture",
    JSTERLING: "jsterling",
    PEDIM: "pedim",
    QCM: "qcm",
    DANIBLIFTING: "daniblifting",
    MHST: "mhst",
    SLEEPCARE: "sleep-care",
    LANDING_PAGES: LandingPages,
    DEAL_PAGES: DealPages,
    MEDIA_TYPES: MediaTypes,
    CATEGORIES: Categories
});


export default Common;